import React from 'react';
import { Hero } from '../components/Hero';
import { About } from '../components/About';
import { Products } from '../components/Products';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { Location } from '../components/Location';
import { CallToAction } from '../components/CallToAction';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-screen bg-white" data-id="element-167">
      <nav className="absolute top-0 left-0 right-0 z-50 p-6" data-id="element-168">
        <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-169">
          <div className="text-white font-bold text-xl flex items-center gap-2" data-id="element-170">
            {/* Simple text logo for the nav overlay */}
            <span className="tracking-tight" data-id="element-171">GAUCHOS</span>
          </div>
        </div>
      </nav>

      <main data-id="element-172">
        <Hero data-id="element-173" />
        <About data-id="element-174" />
        <Products data-id="element-175" />
        <WhyChooseUs data-id="element-176" />
        <Location data-id="element-177" />
        <CallToAction data-id="element-178" />
      </main>

      <Footer data-id="element-179" />
    </div>;
}